var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found container"},[_c('span',{staticClass:"title-404 font-roboto-mono d-flex font-weight-lighter m-auto text-center mb-5 p-4"},[_vm._v(" 401 ")]),_c('h1',{staticClass:"text-center mt-5"},[_vm._v(" Not Authorized ")])])
}]

export { render, staticRenderFns }